<template>
  <v-content class="">
    <section>
      <v-parallax
        :src="require('@/assets/beach-tsv2.jpg')"
        height="500"
        class="banner"
      >
        <Navbar></Navbar>

        <v-layout column class="white--text " justify-end>
          <div>
            <v-container justify-end>
              <div class=" display-1  mt-3 subpage-heading-1 ">
                The Inspection Process
              </div>
              <div class=" headline  mt-3 subpage-heading-2 ">
                Learn about the inspection process!
              </div>
            </v-container>
          </div>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container grid-list-xl class=" white-background">
        <v-layout row wrap align-center>
          <v-flex xs12>
            <v-card class="elevation-0 transparent text-xs-center">
              <h2 class="headline pa-2">
                Learn More About the Inspection Process
              </h2>
              <span class="subheading pa-2">What to Expect</span>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section>
      <v-container class="white-background">
        <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
          <v-timeline-item
            v-for="(item, i) in items"
            :key="i"
            :color="item.color"
            :icon="item.icon"
            :dense="dense"
            fill-dot
          >
            <v-card :color="item.color" dark flat>
              <v-card-title class="title">{{ item.header }}</v-card-title>
              <v-card-text class="white text--primary">
                <p>{{ item.text }}</p>
                <v-btn
                  :color="item.color"
                  class="mx-0"
                  outlined
                  @click="$vuetify.goTo(item.link, {})"
                >
                  More Info
                </v-btn>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-container>
    </section>

    <section>
      <v-container class=" white-background">
        <v-flex xs12>
          <v-card class="elevation-0 transparent ">
            <h2 class="headline pa-2" id="start">
              Participating in the Program
            </h2>
          </v-card>
        </v-flex>
        <v-timeline align-top dense clipped class="ml-5 mr-5  pr-5">
          <v-timeline-item
            color="#4CABDB"
            fill-dot
            clipped
            icon="mdi-account"
            id="person"
          >
            <v-card flat class="elevation-0 transparent ">
              <v-card-title class="title"
                >Appoint An Authorised Person</v-card-title
              >
              <v-card-text class="white text--primary">
                <p>
                  The Authorised Person is someone who has been voted in by the
                  Body Corporate Committee to represent the property in the
                  following:
                </p>
                <ul>
                  <li>
                    registering in the program
                  </li>
                  <li>
                    contact person for the property within the program
                  </li>
                  <li>
                    responsible for supplying and updating correct information
                    regarding the property
                  </li>
                  <li>
                    is the contact person for the inspector to arrange a time to
                    undertake the inspection
                  </li>
                  <li>
                    can appoint another person to be present during the
                    inspection
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-timeline-item>
          <v-timeline-item
            color="#4CABDB"
            fill-dot
            clipped
            icon="mdi-account-edit-outline"
            id="register"
          >
            <v-card flat class="elevation-0 transparent ">
              <v-card-title class="title">Register</v-card-title>
              <v-card-text class="white text--primary">
                <p>
                  Register for the NQSTIP program using the link below. You will
                  receive your login credentials within two business days.
                </p>
                <v-btn
                  color="#4CABDB"

                  class="mx-0 white--text"
                  outlined
                  @click="gotoRegister"
                >
                  Register
                </v-btn>
              </v-card-text>
            </v-card>
          </v-timeline-item>

          <v-timeline-item
            color="#4CABDB"
            fill-dot
            clipped
            icon="mdi-account-arrow-right"
            id="request"
          >
            <v-card flat class="elevation-0 transparent ">
              <v-card-title class="title">Request An Inspection</v-card-title>
              <v-card-text class="white text--primary">
                <p>
                  Login to your account with your login details and go to the
                  "My Sites" tab on the left. Enter the address of your site and
                  click the "Add" button. A site will be created with the
                  entered address. After this you can fill out information about
                  your site. You can also specify when you want to schedule an
                  inspection. After you have entered this information and you
                  are ready to submit your site for an inspection press the
                  "Submit" button next to your site to complete your inspection
                  request.
                </p>
                <v-btn color="#4CABDB" class="mx-0 white--text" outlined @click="gotoLogin">
                  AP Login
                </v-btn>
              </v-card-text>
            </v-card>
          </v-timeline-item>
          <v-timeline-item
            color="#4CABDB"
            fill-dot
            clipped
            icon="mdi-calendar-range"
            id="inspection"
          >
            <v-card class="elevation-0 transparent " flat>
              <v-card-title class="title">The Inspection</v-card-title>
              <v-card-text class="white text--primary">
                <p>
                  After you have successfully applied for an inspection the
                  inspector will contact you to arrange an appointment. Please
                  note that the timing of the inspection will depend on the
                  level of demand for inspections and the availability of
                  inspectors in your area.
                </p>
                <p>
                  The inspector will be able to give you an indication of how
                  long the inspection will take when they phone to arrange an
                  appointment. It will depend on the number of buildings on your
                  property, and the size of the grounds. As part of their
                  preparation for the on-site inspection they will also ask some
                  preliminary questions over the phone, such as the year the
                  buildings were constructed, if there have been any structural
                  upgrades, whether there is a cyclone preparation plan for the
                  property.
                </p>
                <p>
                  During the site inspection, the inspector will need to discuss
                  aspects of your property with you and will need access to the
                  grounds, a lower storey unit, a unit immediately under the
                  roof, the roof, the roof space (through the access hole), and the basement.
                </p>
                <p>
                  Some of the things the inspector will assess include:
                </p>

                <ul>
                  <li>Whether your property is in a storm tide prone area</li>
                  <li>
                    Number of swimming pools, patios, pergolas, carports, shade
                    sail structures
                  </li>
                  <li>
                    Type and condition of fences
                  </li>
                  <li>
                    Number of large trees
                  </li>
                  <li>
                    Type and condition of roof cladding, fasteners and flashings
                  </li>
                  <li>
                    Number of roof top items e.g. solar hot water panels, solar
                    photovoltaic panels, aerials, air conditioners
                  </li>
                  <li>
                    Type of windows
                  </li>
                  <li>
                    Whether there are screens or shutters on the windows
                  </li>
                  <li>
                    Condition of the seals on windows and glass sliding doors
                  </li>
                  <li>
                    Type of garage doors
                  </li>
                  <li>
                    Whether the building has a basement Location of sensitive
                    electrical equipment
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-timeline-item>

          <v-timeline-item
            color="#4CABDB"
            fill-dot
            clipped
            icon="mdi-file-chart"
            id="report"
          >
            <v-card flat class="elevation-0 transparent ">
              <v-card-title class="title">The Report</v-card-title>
              <v-card-text class="white text--primary">
                <p>
                  The Report will provide scores between 0 and 5 for each
                  resilience category (grounds, wind, rain, storm tide and
                  ancillaries), which estimate the likely resilience of your
                  property to damage during a future tropical cyclone:
                </p>
                <ul class="pb-3">
                  <li>
                    0 to 1.5 = very low resilience (very likely there will be
                    significant damage in a future cyclone)
                  </li>
                  <li>
                    1.6 to 2.4 = low resilience (likely there will be
                    significant damage in a future cyclone)
                  </li>
                  <li>
                    2.5 to 2.9 = medium resilience (possible that
                    there will be some damage in a future cyclone)
                  </li>
                  <li>
                    3.0 to 4.0 = high resilience (unlikely there will be
                    significant damage in a future cyclone)
                  </li>
                  <li>
                    4.1 to 5.0 = very high resilience (very unlikely there will be
                    significant damage in a future cyclone)
                  </li>
                </ul>

                <p>
                  The Report will also include some recommendation on activities
                  you could undertake to minimise the damage from future tropical cyclones.
                  See below for some examples.
                </p>
                <p>
                  Your report will be emailed to you within a couple of weeks
                  following the inspection.
                </p>

                <v-btn
                        class="mt-3 mb-3 mr-3 "
                        color="#4CABDB"
                        large
                        dark
                        outlined
                        href="https://www.jcu.edu.au/?a=1171395"

                >
                  Look at A Sample Report
                </v-btn>
              </v-card-text>
            </v-card>
          </v-timeline-item>

          <v-timeline-item
            color="#4CABDB"
            fill-dot
            clipped
            icon="mdi-clipboard-list-outline"
            id="mitigation"
          >
            <v-card flat class="elevation-0 transparent ">
              <v-card-title class="title"
                >Recommendations</v-card-title
              >
              <v-card-text class="white text--primary">
                <p>
                  The Report will also include suggestions of changes, upgrades,
                  maintenance and other activities you could undertake to
                  minimise potential damage to your property from future
                  tropical cyclones. They are presented as options for you to
                  consider. The recommendations will be specific to your
                  property, but may include:
                </p>
                <ul>
                  <li>
                    Replace deteriorated roof cladding and fasteners.
                  </li>
                  <li>
                    Install overflows in eaves or box gutters.
                  </li>
                  <li>
                    Trim or remove trees that overhang buildings.
                  </li>
                  <li>
                    Install debris rated shutters on windows or use temporary
                    debris shutters.
                  </li>
                  <li>
                    Repair any patios, pergolas or carports that are in poor
                    condition.
                  </li>
                  <li>
                    Develop a comprehensive cyclone preparation plan for the
                    property that includes taking down shade sails, storing
                    outdoor furniture under cover, tying down any loose items,
                    etc.
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-container>
    </section>

    <Footer></Footer>
  </v-content>
</template>

<style></style>

<script>
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";
import { router } from "../router";

export default {
  name: "Process",
  components: {
    Navbar,
    Footer
  },
  data: () => ({
    items: [
      {
        color: "#27C5DA",
        icon: "mdi-account",
        header: "1. Appoint an Authorised Person",
        text:
          "The Strata body appoints a representative called the Authorised Person.The Authorised Person is someone who has been voted in by the Body Corporate Committee to represent the property.",
        link: "#person"
      },
      {
        color: "#46B3FD",
        icon: "mdi-account-edit-outline",
        header: "2. Register",
        text: "Complete the registration form on the strata portal.",
        link: "#register"
      },
      {
        color: "#4CABDB",
        icon: "mdi-account-arrow-right",
        header: "3. Request an insepction",
        text:
          "You will be provided with login details. Login to your account. Fill in information about your site. Submit your site for an inspection.",
        link: "#request"
      },

      {
        color: "#46B3FD",
        icon: "mdi-calendar-range",
        header: "4. Inspection",
        text:
          "Even before your property is assessed, you can undertake measures to improve the resilience of your property to damage from the effects of tropical cyclones. You will be contacted by an Inspector to schedule the inspection.",
        link: "#inspection"
      },
      {
        color: "#4CABDB",
        icon: "mdi-file-chart",
        header: "5. Report",
        text:
          "Your report will include resilience scores and mitigation options.",
        link: "#report"
      },

      {
        color: "#27C5DA",
        icon: "mdi-clipboard-list-outline",
        header: "6. Recommendations",
        text:
          "Strata Body considers resilience and undertakes selected mitigation options, and may communicate with insurer.",
        link: "#mitigation"
      }
    ]
  }),
  methods: {
    gotoHome() {
      router.push("/");
    },
    gotoLogin() {
      router.push("/login");
    },
    gotoHelp() {
      router.push("/faq");
    },
    gotoDamage() {
      router.push("/damage");
    },
    gotoAbout() {
      router.push("/about");
    },
    gotoProcess() {
      router.push("/process");
    },
    gotoResilience() {
      router.push("/resilience");
    },
    gotoInspectorLogin() {
      router.push("/ins-login");
    },
    gotoRegister() {
      router.push("/registration");
    }
  }
};
</script>
